import { getCookie } from './cookies';

const isDebugModeActive = () =>
  window.location.href.indexOf('degustacao-debug') !== -1 ||
  getCookie('degustacao-debug') === 'true';

export default isDebugModeActive;
